
import { Component, Prop, Vue } from "nuxt-property-decorator";
import PlaceList from "../PlaceList.vue";

@Component({
  components: {
    PlaceList,
  },
})
export default class AgencyDeliveryArea extends Vue {
  @Prop() agencyName: string;
  @Prop() city?: string;
  @Prop() deliveryDistricts: string[];
  @Prop({ default: 20 }) limit: number;
}
